export const mutations = {
  MutationRegisterLoadingStatus(state, status) {
    state.registerLoadingStatus = status;
  },
  MutationRegister(state, register) {
    state.getRegister = register;
  },
  MutationRegister(state, register) {
    state.getRegister = register;
  },
  MutationGoogleProfile(state, googleProfile) {
    state.googleProfile = googleProfile;
  },
  MutationMicrosoftProfile(state, microsoftProfile) {
    state.microsoftProfile = microsoftProfile;
  },

  MutationSetAcceptInvitationLoadingStatus(state, status) {
    state.acceptInvitationLoadingStatus = status;
  },
  MutationSetAcceptInvitationLoadingStatusV2(state, status) {
    state.acceptInvitationLoadingStatusV2 = status;
  },
  MutationSetAcceptInvitationModel(state, _acceptInvitationModel) {
    state.acceptInvitationModel = _acceptInvitationModel;
  },
  MutationSetAcceptInvitationModelV2(state, _acceptInvitationModel) {
    state.acceptInvitationModelV2 = _acceptInvitationModel;
  },
  MutationSetInsertUserProfileConsentLoadingStatus(state, status) {
    state.insertUserProfileConsentLoadingStatus = status;
  },
  MutationSetRegisterModel(state, registerModel) {
    state.registerModel = registerModel;
  },
  MutationSetGetUserProfileConsentLoadingStatus(state, status) {
    state.getUserProfileConsentLoadingStatus = status;
  },
  MutationSetUserprofileConsentModel(state, userprofileConsentModel) {
    state.userprofileConsentModel = userprofileConsentModel;
  },
  MutationSetGetUserSenderInvitationDetailLoadingStatus(state, status) {
    state.getUserSenderInvitationDetailLoadingStatus = status;
  },
  MutationSetGetGetUserSenderInvitationDetail(state, senderInvitationDetail) {
    state.getUserSenderInvitationDetail = senderInvitationDetail;
  },
  MutationGetInvitationInRoleLoadingStatus(state, status) {
    state.getInvitationInRoleLoadingStatus = status;
  },
  MutationGetInvitationInRole(state, invitationInRole) {
    state.getInvitationInRole = invitationInRole;
  },
};
